(function(){
  'use strict';
  const loader=document.querySelector('[data-pa-page-loader]');
  if(!loader || typeof loader.showModal!=='function')return;
  if(window.Shopify && window.Shopify.designMode)return;
  const delay=Math.min(60,Math.max(1,Number(loader.dataset.delay)||20))*1000;
  loader.style.setProperty('--pa-logo-duration',delay+'ms');
  const priorFocus=document.activeElement;
  let finished=false,minimumElapsed=false,ready=document.readyState==='complete';
  let minimumTimer,fallbackTimer;
  const storyTimers=[];
  function finish(immediate){
    if(finished)return;
    finished=true;
    clearTimeout(minimumTimer);clearTimeout(fallbackTimer);
    storyTimers.forEach(clearTimeout);
    window.removeEventListener('load',onLoad);
    loader.classList.add('is-finished');
    function close(){
      if(loader.open)loader.close();
      if(priorFocus && priorFocus!==document.body && priorFocus.isConnected)priorFocus.focus({preventScroll:true});
    }
    if(immediate)close();else setTimeout(close,reduced ? 200 : 1450);
  }
  function check(){if(minimumElapsed && ready)finish(false)}
  function onLoad(){ready=true;check()}
  loader.querySelector('[data-pa-skip]').addEventListener('click',function(){finish(false)});
  loader.addEventListener('cancel',function(event){event.preventDefault();finish(false)});
  window.addEventListener('pageshow',function(event){if(event.persisted)finish(true)});
  loader.dataset.carePhase='many';
  const storyText=loader.querySelector('#pa-loading-detail');
  const reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function phase(name,text){loader.dataset.carePhase=name;if(storyText)storyText.textContent=text}
  loader.showModal();
  if(reduced){
    phase('lighter','Reviewing medicines can help reduce medication burden.');
  }else{
    [[0.26,'review','The pharmacist checks the medicines.'],
     [0.52,'simplify','Appropriate changes are agreed with the prescriber.'],
     [0.75,'lighter','Fewer medicines, when appropriate. A lighter routine.']
    ].forEach(function(item){storyTimers.push(setTimeout(function(){phase(item[1],item[2])},delay*item[0]))});
  }
  window.addEventListener('load',onLoad,{once:true});
  minimumTimer=setTimeout(function(){minimumElapsed=true;check()},delay);
  fallbackTimer=setTimeout(function(){finish(false)},delay+5000);
})();
